import { ConfigurationDTO } from '../../../Domain/DTO/ConfigurationDTO';
import { BaseEntityPropsInitial, IBaseEntityProps } from '../BaseEntity/IBaseEntityProps';
import { IPortalConfigurationHelperProps, PortalConfigurationHelperPropsInitial } from './IHelperProps';

export interface IPortalConfigurationProps extends IBaseEntityProps<ConfigurationDTO, IPortalConfigurationHelperProps> {
}

export const PortalConfigurationPropsInitial: IPortalConfigurationProps = { ...BaseEntityPropsInitial, DataHelper: PortalConfigurationHelperPropsInitial};